import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
};

export const testimonialSlice = createSlice({
  name: 'testimonial',
  initialState,
  reducers: {
    getTestimonials: (state) => {
      state.loading = true;
    },
    successTestimonial: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    failedTestimonial: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getTestimonials,
  successTestimonial,
  failedTestimonial,
} = testimonialSlice.actions;

export default testimonialSlice.reducer;
